import config from "config/config";
import { authService } from "./authService";

export const flowService = {
    setFlowMode,
    getInsights,
    sendFlowFeedback,
};

async function setFlowMode(mode: string) {
    const requestOptions = {
        method: "PUT",
        body: JSON.stringify({ mode }),
    };

    const res = await authService.apiGate(`${config.API_URL}/api/v1/ldb/flow/mode`, requestOptions);
    return res;
}

async function getInsights() {
    const requestOptions = {
        method: "GET",
    };

    const res = await authService.apiGate(`${config.API_URL}/api/v1/ldb/insights`, requestOptions);
    return res;
}

async function sendFlowFeedback(data: Record<string, any> | Array<Record<string, any>>) {
    const requestOptions = {
        method: "POST",
        body: JSON.stringify(data),
    };

    const res = await authService.apiGate(
        `${config.API_URL}/api/v1/ldb/flow-feedback`,
        requestOptions
    );
    return res;
}
